import React, { ReactElement } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { STRIPE_PK } from 'gatsby-env-variables'
import { Plans } from 'components/Plans/Plans'
import { AlertContextProvider } from 'ui'
import { getDocumentHead } from 'components/DocumentHead'

// moving stripe promise out of the component to prevent it getting recreated at every render since
// this throws the warning Unsupported prop change on Elements: You cannot change the `stripe` prop
// after setting it
const stripePromise = loadStripe(STRIPE_PK)
export default function PlansPage(): ReactElement {
  return (
    <AlertContextProvider>
      <Elements stripe={stripePromise}>
        <Plans />
      </Elements>
    </AlertContextProvider>
  )
}

export const Head = getDocumentHead({
  title: 'Pricing for Personal Use',
  description:
    'Control D pricing for personal users—fast, private, and customizable DNS filtering. No logs, no restrictions, just total browsing control. Choose your plan today!',
})
